import React__default, { useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Button } from '../Button/index.js';
import useFormat from '../../helpers/use-format.js';
import { Link } from 'react-router-dom';
import { pointsPriceByID } from '../../helpers/points.js';
import { PriceSplit } from '../PriceSplit/index.js';
import styles from 'ui-components/CartMini.scss';
import { CrossSvg } from '../../icons/index.js';

var _excluded = ["to", "children"];
var mapProductInfo = function mapProductInfo(x) {
  if (x.configOption) {
    return _extends({}, x.product, x.configOption.product);
  }
  return x.product;
};
var CartMini = function CartMini(_ref) {
  var _cn, _cn2;
  var onClose = _ref.onClose,
    quoteData = _ref.quoteData,
    className = _ref.className,
    altUrl = _ref.altUrl,
    _ref$paymentId = _ref.paymentId,
    paymentId = _ref$paymentId === void 0 ? "awardit" : _ref$paymentId,
    _ref$ctaUrl = _ref.ctaUrl,
    ctaUrl = _ref$ctaUrl === void 0 ? "/checkout" : _ref$ctaUrl,
    _ref$showHeader = _ref.showHeader,
    showHeader = _ref$showHeader === void 0 ? false : _ref$showHeader,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    formatPriceExt = _ref.formatPriceExt;
  var t = useTranslate();
  var _useState = useState(false),
    botAligned = _useState[0],
    setBotAligned = _useState[1];
  var _useState2 = useState(false),
    topAligned = _useState2[0],
    setTopAligned = _useState2[1];
  if (!quoteData.data) {
    return null;
  }
  var items = quoteData.data.items;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.miniCart, className, "awardit-miniCart")
  }, showHeader && /*#__PURE__*/React__default.createElement("header", {
    className: styles.header
  }, /*#__PURE__*/React__default.createElement("span", null, t("CART.HEADING")), /*#__PURE__*/React__default.createElement(LinkButton, {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement("img", {
    src: CrossSvg,
    className: styles.icon
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: styles.list_container
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.shadow_top, (_cn = {}, _cn[styles.shadow__hidden] = topAligned, _cn))
  }), /*#__PURE__*/React__default.createElement(ItemList, {
    items: items,
    quoteData: quoteData,
    variant: variant,
    paymentId: paymentId,
    setTopAligned: setTopAligned,
    setBotAligned: setBotAligned,
    formatPriceExt: formatPriceExt
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.shadow_bottom, (_cn2 = {}, _cn2[styles.shadow__hidden] = botAligned, _cn2))
  }), /*#__PURE__*/React__default.createElement(CartInfo, {
    variant: variant,
    quoteData: quoteData,
    paymentId: paymentId,
    formatPriceExt: formatPriceExt
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.bottom
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    variant: "primary",
    to: ctaUrl,
    disabled: items.length === 0
  }, t("CART.CTA")), altUrl && altUrl.length > 0 && /*#__PURE__*/React__default.createElement(LinkButton, {
    variant: "ghost",
    to: altUrl,
    className: cn(styles.altButton)
  }, t("CART.ALT")), (!altUrl || altUrl.length === 0) && showHeader === false && /*#__PURE__*/React__default.createElement(LinkButton, {
    variant: "ghost",
    onClick: onClose
  }, t("CART.CONTINUE_SHOPPING")))));
};
var ItemList = function ItemList(_ref2) {
  var items = _ref2.items,
    quoteData = _ref2.quoteData,
    variant = _ref2.variant,
    paymentId = _ref2.paymentId,
    setTopAligned = _ref2.setTopAligned,
    setBotAligned = _ref2.setBotAligned,
    formatPriceExt = _ref2.formatPriceExt;
  var _useFormat = useFormat(),
    formatPrice = _useFormat.formatPrice,
    formatPoints = _useFormat.formatPoints;
  var refBody = useRef();
  var refInnerBody = useRef();
  var processingItem = typeof quoteData.processingItem !== "undefined" ? quoteData.processingItem : null;
  var currVat = variant === "b2b" ? "exVat" : "incVat";
  var cartItemHidden = function cartItemHidden() {
    var refBodyRect = refBody.current && refBody.current.getBoundingClientRect();
    var refInnerBodyRect = refInnerBody.current && refInnerBody.current.getBoundingClientRect();
    if (refBodyRect && refInnerBodyRect) {
      setTopAligned(refBodyRect.top !== 0 && refBodyRect.top <= refInnerBodyRect.top);
      setBotAligned(refBodyRect.top !== 0 && refBodyRect.bottom >= refInnerBodyRect.bottom - 5);
    }
  };
  useEffect(function () {
    var ref = refBody;
    if (ref.current) {
      ref.current.addEventListener("scroll", cartItemHidden, {
        passive: true
      });
    }
    cartItemHidden();
    return function () {
      if (ref.current) {
        ref.current.removeEventListener("scroll", cartItemHidden);
      }
    };
  }, [refBody]);
  if (items.length === 0) {
    return null;
  }
  var selectedPointPayment = quoteData.data.selectedPointPayment;
  return /*#__PURE__*/React__default.createElement("div", {
    ref: refBody,
    className: styles.list
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: refInnerBody
  }, items.map(function (x) {
    var _cn3, _product$attributes$i;
    var product = mapProductInfo(x);
    var pointsId = selectedPointPayment ? selectedPointPayment.id : paymentId;
    var pointsPrice = selectedPointPayment || x.availablePointPayments ? pointsPriceByID(x.availablePointPayments, pointsId) : null;
    var paymentCostValues = function paymentCostValues() {
      if (pointsPrice && pointsPrice.points) {
        return formatPoints(pointsPrice.points.value[currVat] / x.qty);
      }
      return formatPriceExt !== undefined ? formatPriceExt(x.product.price.incVat) : formatPrice(x.product.price.incVat);
    };
    return /*#__PURE__*/React__default.createElement("div", {
      key: x.itemBuyRequest,
      className: cn(styles.item, (_cn3 = {}, _cn3[styles.processing] = processingItem === x.itemBuyRequest, _cn3[styles.disabled] = quoteData.state === "UPDATING", _cn3))
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.itemBody
    }, /*#__PURE__*/React__default.createElement("img", {
      className: styles.itemImg,
      src: (_product$attributes$i = product.attributes.image) == null ? void 0 : _product$attributes$i.x1
    }), /*#__PURE__*/React__default.createElement("div", {
      className: styles.itemTextContainer
    }, /*#__PURE__*/React__default.createElement("p", {
      className: styles.itemName
    }, product.name), variant !== "zupergift" && /*#__PURE__*/React__default.createElement("p", {
      className: styles.itemBrand
    }, product.attributes.manufacturer), /*#__PURE__*/React__default.createElement("p", {
      className: styles.itemQty
    }, x.qty, " x ", paymentCostValues()))));
  })));
};
var CartInfo = function CartInfo(_ref3) {
  var quoteData = _ref3.quoteData,
    variant = _ref3.variant,
    paymentId = _ref3.paymentId,
    formatPriceExt = _ref3.formatPriceExt;
  var t = useTranslate();
  var _useFormat2 = useFormat(),
    formatPrice = _useFormat2.formatPrice,
    formatPoints = _useFormat2.formatPoints;
  var _quoteData$data = quoteData.data,
    items = _quoteData$data.items,
    subTotal = _quoteData$data.subTotal,
    shipping = _quoteData$data.shipping,
    isVirtual = _quoteData$data.isVirtual,
    grandTotal = _quoteData$data.grandTotal;
  var availablePointPayments = quoteData.data.availablePointPayments;
  var pointsPayment = availablePointPayments ? pointsPriceByID(availablePointPayments, paymentId) : null;
  var pointsLabel = pointsPayment ? pointsPayment.points.label : null;
  var currVat = variant === "b2b" ? "exVat" : "incVat";
  var getSubTotalVal = function getSubTotalVal() {
    if (pointsPayment && pointsPayment.points) {
      var _shipping = pointsPayment.shipping,
        points = pointsPayment.points;
      if (points && points.value && _shipping && _shipping.points.value) {
        var val = points.value[currVat] - _shipping.points.value[currVat];
        return formatPoints(val, pointsLabel);
      }
      if (points && points.value) {
        return formatPoints(points.value[currVat], pointsLabel);
      }
    }
    return formatPriceExt !== undefined ? formatPriceExt(subTotal.incVat) : formatPrice(subTotal.incVat);
  };
  var getShippingVal = function getShippingVal() {
    if (pointsPayment && pointsPayment.shipping) {
      var pointsShipping = pointsPayment.shipping;
      if (pointsShipping && pointsShipping.points.value) {
        return formatPoints(pointsShipping.points.value[currVat], pointsLabel);
      }
    }
    if (!isVirtual && shipping && shipping.total && shipping.total[currVat] > 0) {
      return formatPriceExt !== undefined ? formatPriceExt(shipping.total[currVat]) : formatPrice(shipping.total[currVat]);
    }
    return null;
  };
  var getGrandTotal = function getGrandTotal() {
    if (pointsPayment && pointsPayment.points) {
      return /*#__PURE__*/React__default.createElement(PriceSplit, {
        className: cn(styles.grandTotal, styles.totalSplit),
        formatPriceExt: formatPriceExt,
        pointsPrice: pointsPayment,
        exVat: variant === "b2b"
      });
    }
    return /*#__PURE__*/React__default.createElement("span", {
      className: styles.grandTotal
    }, formatPriceExt !== undefined ? formatPriceExt(grandTotal[currVat]) : formatPrice(grandTotal[currVat]));
  };
  if (variant === "zupergift") {
    var total = formatPriceExt !== undefined ? formatPriceExt(subTotal.incVat) : formatPrice(subTotal.incVat);
    return /*#__PURE__*/React__default.createElement("div", {
      className: cn(styles.totals, styles.totals__zupergift)
    }, /*#__PURE__*/React__default.createElement("div", {
      className: cn(styles.totalsRow, styles.totalsRow__zupergift)
    }, items.length > 0 ? /*#__PURE__*/React__default.createElement("p", {
      className: styles.total
    }, t("CART.TOTALS"), ": ", total) : /*#__PURE__*/React__default.createElement("p", {
      className: styles.empty
    }, t("CART.EMPTY"))));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.totals
  }, getShippingVal() !== null && /*#__PURE__*/React__default.createElement("div", {
    className: styles.totalsRow
  }, /*#__PURE__*/React__default.createElement("span", null, t("CART.SUBTOTAL"), " "), /*#__PURE__*/React__default.createElement("span", null, getSubTotalVal())), getShippingVal() !== null && /*#__PURE__*/React__default.createElement("div", {
    className: styles.totalsRow
  }, /*#__PURE__*/React__default.createElement("span", null, t("CART.SHIPPING"), " "), /*#__PURE__*/React__default.createElement("span", null, getShippingVal())), /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.totalsRow, styles.totalsRow__grandtotal)
  }, /*#__PURE__*/React__default.createElement("strong", null, t("CART.GRANDTOTAL"), " "), /*#__PURE__*/React__default.createElement("div", null, getGrandTotal())));
};
var LinkButton = function LinkButton(_ref4) {
  var to = _ref4.to,
    children = _ref4.children,
    props = _objectWithoutPropertiesLoose(_ref4, _excluded);
  if (to && to.length > 0) {
    return /^https?:\/\//.test(to) || /^mailto?:/.test(to) || /^tel?:/.test(to) ? /*#__PURE__*/React__default.createElement("a", _extends({}, props, {
      href: to
    }), /*#__PURE__*/React__default.createElement(Button, props, /*#__PURE__*/React__default.createElement("span", null, children))) : /*#__PURE__*/React__default.createElement(Link, {
      to: to,
      style: {
        textDecoration: "none"
      }
    }, /*#__PURE__*/React__default.createElement(Button, props, /*#__PURE__*/React__default.createElement("span", null, children)));
  }
  return /*#__PURE__*/React__default.createElement(Button, props, /*#__PURE__*/React__default.createElement("span", null, children));
};

export { CartInfo, CartMini, ItemList, LinkButton };
//# sourceMappingURL=index.js.map
